<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Edit'}}{{(type)? ' ' + type: ''}}</strong>
        </div>
        <div class="col-md-1">
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
  <div class="card-body">
  <div class>
    <div class="mb5"></div>
    <!-- <vform :formData="editForm" :fields="fields" :submitCallback="showSmallModal"/> -->
    <form @onsubmit.prevent action>
      <div class="row mb5">
        <div class="col-md-4"></div>
        <div class="col-md-3 text-center">
          <label class="form-control-label text-bold" >Equity</label>
        </div>
        <div class="col-md-2 text-center">
          <label class="form-control-label text-bold">Debt</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">Default </div>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <input type="text" class="form-control" v-model="formData['equity']" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <input type="text" class="form-control" v-model="formData['debt']" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-for="field in fields" v-bind:key="field.name">
        <div class="col-md-4">{{getLabel(field.name)}}</div>
        <div class="col-md-8" >
          <div class="row" v-for="subF in Object.keys(allFields[field.name]['subfields'])" v-bind:key="subF+field.label">          
            <div class="col-md-4 col-sm-6 col-xs-6" >
              <div class="form-group" v-if="allFields[field.name]['subfields'][subF] && rawData[field.name] && rawData[field.name]['equity']">
                <label :for="field.name" class="form-control-label" v-if="typeof (rawData[field.name]['equity'][subF]) !== 'undefined'">{{getLabel(subF)}}</label>
                <input
                  v-if="typeof (rawData[field.name]['equity'][subF]) !== 'undefined'"
                  type="field.type"
                  v-model="formData[field.name+'_equity_'+subF]"
                  :id="field.name+'_equity_'+subF"
                  :placeholder="field.placeholder"
                  class="form-control"
                />
                <small v-if="errors[field.name+'_equity_'+subF]" class="form-text text-danger">{{errors[field.name+'_equity_'+subF]}}</small>
                <small v-else-if="field.help" class="form-text text-muted">This is a help text</small>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-6">
              <div class="form-group" v-if="allFields[field.name]['subfields'][subF] && rawData[field.name]['debt']">
                <label :for="field.name" class="form-control-label" v-if="typeof (rawData[field.name]['debt'][subF]) !== 'undefined'">{{getLabel(subF)}}</label>
                <input
                  v-if="typeof (rawData[field.name]['debt'][subF]) !== 'undefined'"
                  type="field.type"
                  v-model="formData[field.name+'_debt_'+subF]"
                  :id="field.name+'_debt_'+subF"
                  :placeholder="field.placeholder"
                  class="form-control"
                >
                <small v-if="errors[field.name+'_debt_'+subF]" class="form-text text-danger">{{errors[field.name+'_debt_'+subF]}}</small>
                <small v-else-if="field.help" class="form-text text-muted">This is a help text</small>
              </div>
              <div class="col-md-4"></div>
              <div class="col-md-4"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group pull-right">
            <button @click="saveMacroData" type="button" class="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
    </form>
    <PinCheck
      :show.sync="show"
      ref="smallModal"
      v-bind:small="true"
      @submitForm="submitForm"
      :cancelClass="'btn btn-secondary'"
    ></PinCheck>
  </div>
  </div>
  </div>
</template>
<script>
// import vform from "@/components/vform";
import { commonMixins } from "../../assets/mixins/common.js";
import http from "@/lib/http";
import PinCheck from "@/components/PinCheck.vue";
export default {
  name: 'DebtRating',
  components: { PinCheck },
  mixins: [commonMixins],
  created() {
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.getRawData();
    } else {
      this.$router.go(-1);
    }
  },
  data() {
    return {
      show: false,
      fields: [],
      formData: {},
      errors: [],
      rawData: [],
      type: 'qualitativeStatements',
      equityFields: ['p11', 'p11_quarterly_trends', 'q1_a_or_b_greater'],
      debtFields: ['p11', 'p11_quarterly_trends', 'q1_a_or_b_greater', 'p11_debt'],
      allFields: [],
      formFields: [
        {
          name: 'range_multiplier',
          label: 'range_multiplier',
          subfields: [
            {name: 'range_multiplier', fields: {equity: null, debt: null}}
          ]
        }
      ]
    };
  },
  methods: {
    submitEditForm: function() {
      let myself = this;
      console.log("submit form", this.formData);
      var formData = this.getFormData();
      http.put(
        "mutual-funds/form?name="+myself.type,
        formData,
        (error, response) => {
          console.log(response);
          if(response.message == 'success') {
            this.$toastr.success("Updated Successfully!", "", {});
          } else {
            this.$toastr.error("Oops, Something went wrong!", "", {});
          }
        }
      );
    },
    setData() {
      var fields = Object.keys(this.rawData);
      // this.fields.push({label: 'rating_multiplier', name: 'rating_multiplier', type: "head", equity: [], debt: []});
      fields.forEach((val, key) => {
        var eq = [];
        var dbt = [];
        if(val != 'form_name' && val !== 'portfolio_overall_rating' && val != 'equity' && val != 'debt') {
          if(val == 'equity'){
            eq.push(        
              {
                label: val,
                name: val,
                type: "number",
                fieldType: val,
                subFields: [],
                value: this.rawData[val]
              }
            );
            this.fields[0].equity = eq;
          } else if(val == 'debt'){
            dbt.push(        
              {
                label: val,
                name: val,
                type: "number",
                fieldType: val,
                subFields: [],
                value: this.rawData[val]
              }
            );
            this.fields[0].debt = dbt;
          }
        }
      });
      fields.forEach((val, key) => {
        if(val == 'portfolio_overall_rating') {
          var equity = [];
          var debt = [];
          Object.keys(this.rawData[val].equity).forEach((sub, subkey) => {
            equity.push(        
              {
                label: sub,
                name: val+'-equity-'+sub,
                type: "number",
                fieldType: 'equity',
                subFields:[],
                value: this.rawData[val].equity[sub]
              }
            );
          });
          Object.keys(this.rawData[val].debt).forEach((sub1, subkey1) => {
            debt.push(        
              {
                label: sub1,
                name: val + '-debt-' + sub1,
                type: "number",
                fieldType: 'debt',
                subFields:[],
                value: this.rawData[val].debt[sub1]
              }
            );
          });
          this.fields.push({label: val, name: val, type: "head", equity: equity, debt: debt});
        } 
      });
      console.log(this.fields);
    },
    setFormData() {
      this.$set(this.formData, 'equity', this.rawData.equity);
      this.$set(this.formData, 'debt', this.rawData.debt);
      for (var index in this.fields) {
        console.log(index, this.fields[index]);
        if(this.fields[index].debt || this.fields[index].equity){
          let field = this.fields[index];
          this.allFields[field.name] = field;
          this.allFields[field.name]['subfields'] = {};
          field.equity.forEach((eq, eqKey) => {
            console.log(eqKey, eq)
            if(!this.allFields[field.name]['subfields'][eq.label]){
              this.allFields[field.name]['subfields'][eq.label] = {};
            }
            // this.allFields[field.name][eq.label] = [];
            if (!field.placeholder) field.placeholder = "";
            if (!field.help) field.help = "";
            this.allFields[field.name]['subfields'][eq.label].equity = eq.value;
            this.formData[field.name+'_equity_'+eq.label] = field.name+'_equity_'+eq.label;
            this.$set(this.formData, field.name+'_equity_'+eq.label, eq.value);
          });
          field.debt.forEach((eq, eqKey) => {
            console.log(eqKey, eq)
            if (!field.placeholder) field.placeholder = "";
            if (!field.help) field.help = "";
            if(!this.allFields[field.name]['subfields'][eq.label]){
              this.allFields[field.name]['subfields'][eq.label] = {};
            }
            this.allFields[field.name]['subfields'][eq.label].debt = eq.value;
            this.formData[field.name+'_debt_'+eq.label] = field.name+'_debt_'+eq.label;
            this.$set(this.formData, field.name+'_debt_'+eq.label, eq.value);
          });
        }
        console.log(this.allFields);
      }
      console.log("this.formData", this.formData);
    },
    getFormData () {
      var formData = {debt: '', equity: '', portfolio_overall_rating: {debt: {}, equity: {} } };
      var fields = Object.keys(this.rawData);
      // this.fields.push({label: 'rating_multiplier', name: 'rating_multiplier', type: "head", equity: [], debt: []});
      fields.forEach((val, key) => {
        if(val == 'equity' || val == 'debt' || val == 'portfolio_overall_rating') {
          if(val !== 'portfolio_overall_rating'){
            formData[val] = this.formData[val];
          } else {
            this.equityFields.forEach((eq, subKey) => {
              formData['portfolio_overall_rating']['equity'][eq] = this.formData[val+'_equity_'+eq];
            });
            this.debtFields.forEach((db, subKey) => {
              formData['portfolio_overall_rating']['debt'][db] = this.formData[val+'_debt_'+db];
            });
          }
        } else {
          formData[val] = this.rawData[val];
        }
      });
      console.log('formData', formData);
      return formData;
    },
    getFixed(num) {
      let n = parseFloat(num).toFixed(2);
      return n != "NaN" ? n : "-";
    },
    cancel(d) {
      console.log("Cancel =>", d);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.submitEditForm();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    saveMacroData() {
      // this.submitForm();
      // this.formData["update"] = 0;
      this.$refs.smallModal.open();
    },
    updateMacroData() {
      // this.formData["update"] = 1;
      // this.$refs.smallModal.open();
    },
    getRawData() {
      http.get(
        "mutual-funds/form?name="+this.type,
        {},
        (error, response) => {
          if (response.message === 'success') {
            this.rawData = response.data;
            this.setData();
            this.setFormData();
          }
        }
      );
    }
  },
  watch: {
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/multiplier-form.vue